import React from 'react';
import { useSelector } from 'react-redux';

const AuthTest = () => {
  const { user, isAuthenticated, token } = useSelector((state) => state.auth);
  
  console.log('AuthTest - Full auth state:', { user, isAuthenticated, token });
  console.log('AuthTest - localStorage token:', localStorage.getItem('token'));
  console.log('AuthTest - localStorage user:', localStorage.getItem('user'));
  
  return (
    <div style={{ padding: '20px' }}>
      <h2>Test d'authentification</h2>
      <div>
        <h3>État Redux Auth:</h3>
        <p><strong>isAuthenticated:</strong> {isAuthenticated ? 'true' : 'false'}</p>
        <p><strong>token:</strong> {token ? 'présent' : 'absent'}</p>
        <p><strong>user:</strong> {user ? JSON.stringify(user, null, 2) : 'absent'}</p>
      </div>
      <div>
        <h3>LocalStorage:</h3>
        <p><strong>token:</strong> {localStorage.getItem('token') ? 'présent' : 'absent'}</p>
        <p><strong>user:</strong> {localStorage.getItem('user') ? 'présent' : 'absent'}</p>
      </div>
    </div>
  );
};

export default AuthTest;